import type { ChevronProps } from "react-day-picker";

export const ChevronIcon = ({ orientation }: ChevronProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.65}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="text-grey6"
  >
    <path d={orientation === "left" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"} />
  </svg>
);
